import { Component, ElementRef, ViewChild, Inject, PLATFORM_ID, AfterViewInit, Renderer2 } from '@angular/core';
import { PeriodService } from '../../../../periods/period.service';
import Swal from 'sweetalert2';
import { ReportPaymentService } from '../../../services/report_payment.service';
import { ExpenseAttachmentsService } from '../../../../shared/services/expense_attachments.service';
import { Modal } from 'bootstrap';
import { isPlatformBrowser } from '@angular/common';


@Component({
  selector: 'app-list-reports-payments',
  templateUrl: './list-reports-payments.component.html',
  styleUrl: './list-reports-payments.component.scss'
})
export class ListReportsPaymentsComponent {
  @ViewChild('AttachmentModal', { static: false }) attachmentModalElement!: ElementRef; attachmentModalInstance!: Modal;

  constructor(
    @Inject(PLATFORM_ID) private platformId: any,

    private periodService: PeriodService,
    private reportPaymentService: ReportPaymentService,
    private expenseAttachmentsService: ExpenseAttachmentsService
  ) { }

  periods: any[] = [];
  selectedPeriod: any = null;
  selectedYear: number = new Date().getFullYear();
  years: number[] = [];
  reportPayment: any = null;
  reportPayments: any[] = [];

  ngOnInit(): void {
    this.generateYearOptions();
    this.loadPeriods();
  }

  generateYearOptions(): void {
    const currentYear = new Date().getFullYear();
    const startYear = 2024; // Cambia esto al año que desees como inicio

    for (let year = startYear; year <= currentYear; year++) {
      this.years.push(year);
    }
  }

  onYearChange(selectedYear: number): void {
    // Aquí puedes manejar el cambio de año seleccionado
    this.selectedYear = selectedYear;
    this.loadPeriods();
  }


  loadPeriods(): void {
    this.periodService.get(this.selectedYear).subscribe({
      next: (response) => {
        if (response && response.length > 0) {
          this.periods = response;
        } else {
          this.periods = [];
          Swal.fire({
            icon: 'warning',
            title: 'No hay periodos disponibles',
            text: `No hay periodos disponibles para el año ${this.selectedYear}.`,
            confirmButtonText: 'Aceptar'
          });
        }
      },
      error: (error) => {
        this.periods = [];
        console.error("Error al cargar los periodos:", error);
      }
    });
  }

  onOpenAttachment(attachment: any) {
    if (!attachment) {
      Swal.fire({
        icon: 'warning',    
        title: 'Adjunto no encontrado',
        text: 'No se pudo encontrar el adjunto seleccionado.',
        confirmButtonText: 'Aceptar'
      });
      return;
    }
    this.reportPaymentService.setCurrentPaymentAttachmentId(attachment._id)
    setTimeout(() => {
      this.openAttachmentModal()
    }, 5)
  }

  openAttachmentModal(): void {
    if (isPlatformBrowser(this.platformId) && this.attachmentModalElement?.nativeElement) {
      import('bootstrap').then(({ Modal }) => {
        this.attachmentModalInstance = new Modal(this.attachmentModalElement.nativeElement);
        this.attachmentModalInstance.show();
      }).catch(error => console.error('Error al inicializar el modal de adjuntos:', error));
    }
  }
  onSearch(): void {
    if (this.selectedPeriod) {
      this.chargePayments(this.selectedPeriod);
    } else {
      Swal.fire({
        icon: 'warning',
        title: 'Periodo no seleccionado',
        text: 'Por favor, selecciona un periodo para cargar los pagos.',
        confirmButtonText: 'Aceptar'
      });
    }
  }

  chargePayments(periodId: any): void {
    console.log("Cargando pagos para el periodo:", periodId);
    if (!periodId) {
      Swal.fire({
        icon: 'warning',
        title: 'Periodo no seleccionado',
        text: 'Por favor, selecciona un periodo para cargar los pagos.',
        confirmButtonText: 'Aceptar'
      });
      return;
    }

    //icono de carga
    Swal.fire({
      title: 'Cargando pagos...',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    // Aquí puedes implementar la lógica para cargar los pagos del periodo seleccionado
    this.reportPaymentService.get(periodId).subscribe({
      next: (response) => {
        // Maneja la respuesta de la carga de pagos
        if (response && response.length > 0) {
          Swal.close(); // Cierra el modal de carga
          this.reportPayments = response;
        } else {
          this.reportPayments = [];
          Swal.close(); // Cierra el modal de carga
          // Mostrar mensaje de que no hay pagos disponibles
          Swal.fire({
            icon: 'info',
            title: 'No hay pagos disponibles',
            text: `No hay pagos registrados para el periodo seleccionado.`,
            confirmButtonText: 'Aceptar'
          });
        }
      },
      error: (error) => {
        console.error("Error al cargar los pagos:", error);
      }
    });
  }

}
